import { CardConfig, TableConfig } from "../models/ui-config.models";

export const LEARNER_TABLE_COLUMNS: TableConfig[] = [
  { key: 'scenarioTitle', title: '__CALLS_SCENARIO__', renderType: 'text', size: 3 },
  { key: 'bestScore', title: '__CALLS_BEST_SCORE__', renderType: 'progress', size: 2.7, format: "%", progressKeys: { completed: "bestScore", percent: "bestScorePercent" } },
  { key: 'firstScore', title: '__CALLS_FIRST_SCORE__', renderType: 'text', size: 2, format: '1.2-2', unit: "%" },
  { key: 'timeToMasteryText', title: '__CALLS_ATTEMPTS_TIME_TO_MASTERY__', renderType: 'text', size: 2 },
  { key: 'improvementText', title: '__CALLS_IMPROVEMENT__', renderType: 'chip', size: 2 },
];

export const LEARNER_CARDS: CardConfig[] = [
  {
    key: 'firstScore',
    title: 'First Score',
    format: '1.0-0',
    unit: '%',
    iconPath: '/assets/icon/chart-mark.svg',
    iconAlt: 'chart-mark'
  },
  {
    key: 'bestScore',
    title: 'Best Score',
    format: '1.0-0',
    unit: '%',
    iconPath: '/assets/icon/sun-badge.svg',
    iconAlt: 'sun-badge'
  },
  {
    key: 'timeToMastery',
    title: 'Attempts/Time to Mastery',
    format: '1.0-0',
    unit: ' mins',
    iconPath: '/assets/icon/clock-mark.svg',
    iconAlt: 'clock-mark'
  },
  {
    key: 'improvement',
    title: 'Improvement',
    format: '1.0-0',
    unit: '%',
    iconPath: '/assets/icon/chart-growth.svg',
    iconAlt: 'chart-growth'
  }
];

export const EMPTY_DETAILS = {
  id: "",
  userId: "",
  aiAgentId: 0,
  firstAttemptScore: 0,
  bestAttemptScore: 0,
  thresholdAttempt: 0,
  totalAttempts: 0,
  totalScore: 0,
  thresholdDuration: 0,
  totalDuration: 0,
  aiAgent: {
    id: 0,
    client_id: 0,
    agentFirstName: "",
    threshold: 0
  }
}
